/* =====================================================================
   EE Shoppable Blog — Prototyp 2026-06-15  (nur Artikelseiten)
   Saeule A: Hover (Desktop) / Tap (Mobil) -Produkt-Preview ueber Produkt-/
             Collection-Links im Artikel (Text-Links UND verlinkte Bilder).
   Saeule B: Bilder shoppbar — Reihenfolge: (1) Bild im Link (Autor verlinkt
             das Bild im Editor), (2) data-ee-* Attribute, (3) Theme-Map,
             (4) Halbautomatik (Material-Stichwort im Alt -> Collection).
   Datenquelle: /products/{handle}.js ; Collections via Section Rendering
                /collections/{handle}?section_id=ee-hovercard.
   Mobil: Popup NUR bei Bildern (Tap); Links/Chips/Buttons navigieren nativ.
   Desktop: Hover-Vorschau auf Bildern UND allen Produkt-/Collection-Links (inkl. button-
   gestylte Chips). Hover-vs-Tap an Viewport-Breite (>=768) — so zeigen Maus-Emulatoren das Handy-Verhalten.
   Laeuft aus einem Asset-File (Inline-Scripts in Sections sind inert).
   ===================================================================== */
(function () {
  'use strict';
  if (window.__eeShoppable) return; window.__eeShoppable = true;

  var CFG = window.EE_SHOPPABLE || {};
  var CART_ADD = CFG.cartAddUrl || (window.routes && window.routes.cartAddUrl) || '/cart/add.js';
  var MONEY = CFG.moneyFormat || (window.theme && window.theme.moneyFormat) || '{{amount}} €';
  var ARTICLE = CFG.article || {};
  var MAP = window.EE_SHOPPABLE_MAP || {};
  var amap = MAP[ARTICLE.handle] || null;

  var HOVER_DELAY = 160;   // ms — gegen Fehlausloesung beim Drueberwischen
  var HIDE_DELAY = 240;
  var isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;
  if (isTouch) document.body.classList.add('ee-shop-touch');
  var lastPointerType = 'mouse';   // pro Interaktion gesetzt: 'mouse' | 'touch' | 'pen'

  var cache = {};          // key 'product:handle' / 'collection:handle' -> Promise<html|json>

  /* ---------------- Geld formatieren (Shopify-Format, DE) ---------------- */
  function fmtMoney(cents) {
    if (cents == null || isNaN(cents)) return '';
    var value = (cents / 100);
    function withSep(num, dec) {
      var s = num.toFixed(dec);
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'); // Tausenderpunkt
      return dec ? parts.join(',') : parts[0];                    // Komma als Dezimal
    }
    return MONEY.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return withSep(value, 2);
        case 'amount_no_decimals': return withSep(value, 0);
        case 'amount_with_comma_separator': return withSep(value, 2);
        case 'amount_no_decimals_with_comma_separator': return withSep(value, 0);
        default: return withSep(value, 2);
      }
    });
  }

  /* ---------------- GA4 / dataLayer ---------------- */
  function track(name, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'ee_shoppable_' + name }, params || {}));
      if (typeof window.gtag === 'function') window.gtag('event', 'ee_shoppable_' + name, params || {});
    } catch (e) {}
  }

  /* ---------------- Popup (Singleton) ---------------- */
  var pop, popInner, noteEl, showTimer, hideTimer, anchorEl;
  function ensurePop() {
    if (pop) return;
    pop = document.createElement('div');
    pop.className = 'ee-shop-pop';
    pop.setAttribute('role', 'dialog');
    pop.setAttribute('aria-label', 'Produkt-Vorschau');
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'ee-shop-pop__close';
    closeBtn.setAttribute('aria-label', 'Schließen');
    closeBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6 L18 18 M18 6 L6 18"/></svg>';
    closeBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); hidePop(); });
    pop.appendChild(closeBtn);
    popInner = document.createElement('div');
    popInner.className = 'ee-shop-pop__body';
    pop.appendChild(popInner);
    noteEl = document.createElement('div');
    noteEl.className = 'ee-shop-pop__note';
    noteEl.innerHTML = '<span class="ee-shop-pop__note-i" aria-hidden="true">ℹ️</span> Bepflanzung und Dekoration sind nicht im Lieferumfang enthalten.';
    pop.appendChild(noteEl);
    document.body.appendChild(pop);
    pop.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
    pop.addEventListener('mouseleave', scheduleHide);
  }

  // Popup neben/unter das Element legen (verdeckt es moeglichst nicht) und IMMER im Bildschirm.
  function positionPop(target) {
    var r = target.getBoundingClientRect();
    var pw = pop.offsetWidth, ph = pop.offsetHeight;
    var gap = 12, vw = window.innerWidth, vh = window.innerHeight, m = 10;
    function clamp(v, lo, hi) { return Math.min(Math.max(v, lo), Math.max(lo, hi)); }
    var cx = r.left + r.width / 2 - pw / 2;
    var raw = [
      { l: r.right + gap,     t: r.top },           // rechts daneben
      { l: r.left - gap - pw, t: r.top },           // links daneben
      { l: cx,                t: r.bottom + gap },   // darunter
      { l: cx,                t: r.top - gap - ph }  // darueber
    ];
    var best = null;
    for (var i = 0; i < raw.length; i++) {
      var l = clamp(raw[i].l, m, vw - pw - m);       // jeder Kandidat HART in den Viewport
      var t = clamp(raw[i].t, m, vh - ph - m);
      var ox = Math.max(0, Math.min(l + pw, r.right) - Math.max(l, r.left));
      var oy = Math.max(0, Math.min(t + ph, r.bottom) - Math.max(t, r.top));
      var overlap = ox * oy;                          // Flaeche, die das Element verdeckt
      if (!best || overlap < best.overlap) best = { l: l, t: t, overlap: overlap };
      if (overlap === 0) break;                       // erster verdeckungsfreier Platz gewinnt
    }
    pop.style.left = Math.round(best.l) + 'px';
    pop.style.top = Math.round(best.t) + 'px';
  }

  function openPop(target, source) {
    ensurePop();
    anchorEl = target;
    // Disclaimer-Hinweis nur bei Bild-Triggern (image/featured). Text-Links bekommen ihn nicht.
    if (noteEl) noteEl.style.display = (source === 'link') ? 'none' : '';
    positionPop(target);
    pop.classList.add('is-open');
  }
  function scheduleHide() { clearTimeout(hideTimer); hideTimer = setTimeout(hidePop, HIDE_DELAY); }
  function hidePop() { clearTimeout(showTimer); clearTimeout(hideTimer); if (pop) pop.classList.remove('is-open'); anchorEl = null; }

  /* ---------------- Daten holen (lazy + cache) ---------------- */
  function getProduct(handle) {
    var key = 'product:' + handle;
    if (!cache[key]) {
      cache[key] = fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .catch(function (e) { delete cache[key]; throw e; }); // Cache nicht mit rejected Promise vergiften
    }
    return cache[key];
  }
  function getCollectionCard(handle) {
    var key = 'collection:' + handle;
    if (!cache[key]) {
      cache[key] = fetch('/collections/' + handle + '?section_id=ee-hovercard')
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .catch(function (e) { delete cache[key]; throw e; });
    }
    return cache[key];
  }

  /* ---------------- Render ---------------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }

  function renderProduct(p, label, compact) {
    var v = (p.variants && p.variants[0]) || {};
    var available = p.available;
    // erste 2 Produktbilder (im Multi-Popup nur 1, kompakter)
    var imgs = (p.images && p.images.length ? p.images.slice() : (p.featured_image ? [p.featured_image] : [])).slice(0, compact ? 1 : 2);
    var gallery = imgs.map(function (u) {
      if (u.indexOf('//') === 0) u = 'https:' + u;
      var us = u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=300';
      return '<a href="' + esc(p.url) + '" data-ee-cta="1"><img src="' + esc(us) + '" alt="' + esc(p.title) + '" loading="eager"></a>';
    }).join('');
    var galCls = imgs.length >= 2 ? 'ee-shop-card__gallery--2' : 'ee-shop-card__gallery--1';
    var priceHtml = fmtMoney(p.price);
    if (p.compare_at_price && p.compare_at_price > p.price) {
      priceHtml += ' <del>' + fmtMoney(p.compare_at_price) + '</del>';
    }
    var availCls = available ? '' : ' ee-shop-card__avail--out';
    var availTxt = available ? 'Auf Lager · sofort lieferbar' : 'Derzeit nicht verfügbar';
    var atc = available
      ? '<button type="button" class="button button--small button--primary ee-shop-atc" data-vid="' + v.id + '" data-handle="' + esc(p.handle) + '">In den Warenkorb</button>'
      : '';
    return '' +
      '<div class="ee-shop-card ee-shop-card--grid">' +
        '<div class="ee-shop-card__gallery ' + galCls + '">' + gallery + '</div>' +
        '<div class="ee-shop-card__body">' +
          '<span class="ee-shop-card__kicker">' + esc(label || 'Produkt') + '</span>' +
          '<a class="ee-shop-card__title" href="' + esc(p.url) + '" data-ee-cta="1">' + esc(p.title) + '</a>' +
          '<span class="ee-shop-card__price">' + priceHtml + '</span>' +
          '<span class="ee-shop-card__avail' + availCls + '">' + availTxt + '</span>' +
          '<div class="ee-shop-card__actions">' + atc +
            '<a class="button button--small button--secondary" href="' + esc(p.url) + '" data-ee-cta="1">Zum Produkt</a>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function showProduct(target, handle, label, source) {
    openPop(target, source);
    popInner.innerHTML = '<div class="ee-shop-card__loading">Lädt …</div>';
    getProduct(handle).then(function (p) {
      if (!pop.classList.contains('is-open') || anchorEl !== target) return;
      popInner.innerHTML = renderProduct(p, label);
      positionPop(target);
      track('open', { ee_type: 'product', ee_handle: handle, ee_source: source });
    }).catch(function () {
      popInner.innerHTML = '<div class="ee-shop-card__loading">Vorschau nicht verfügbar. <a href="/products/' + esc(handle) + '">Zum Produkt</a></div>';
    });
  }
  function showCollection(target, handle, label, source) {
    openPop(target, source);
    popInner.innerHTML = '<div class="ee-shop-card__loading">Lädt …</div>';
    getCollectionCard(handle).then(function (html) {
      if (!pop.classList.contains('is-open') || anchorEl !== target) return;
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var card = tmp.querySelector('.ee-shop-card') || tmp;
      popInner.innerHTML = card.outerHTML || card.innerHTML;
      positionPop(target);
      track('open', { ee_type: 'collection', ee_handle: handle, ee_source: source });
    }).catch(function () {
      popInner.innerHTML = '<div class="ee-shop-card__loading">Vorschau nicht verfügbar. <a href="/collections/' + esc(handle) + '">Zur Kollektion</a></div>';
    });
  }
  function show(target, type, handle, label, source) {
    if (type === 'collection') showCollection(target, handle, label, source);
    else showProduct(target, handle, label, source);
  }
  // Mehrere Produkte/Collections gestapelt in EINEM Popup (Kategorien + Produkte untereinander)
  function showMulti(target, items, source) {
    openPop(target, source);
    popInner.innerHTML = '<div class="ee-shop-card__loading">Lädt …</div>';
    Promise.all(items.map(function (it) {
      if (it.type === 'collection') return getCollectionCard(it.handle).then(function (html) { return { it: it, html: html }; }, function () { return { it: it, err: 1 }; });
      return getProduct(it.handle).then(function (p) { return { it: it, p: p }; }, function () { return { it: it, err: 1 }; });
    })).then(function (results) {
      if (!pop.classList.contains('is-open') || anchorEl !== target) return;
      var parts = results.map(function (r) {
        if (r.err) return '';
        if (r.p) return renderProduct(r.p, r.it.label, false);  // 2 Bilder NEBENEINANDER (--2) wie Single-Popup: mehr Bild + niedriger als 1 Vollbreit-Bild
        var tmp = document.createElement('div'); tmp.innerHTML = r.html;
        var card = tmp.querySelector('.ee-shop-card');
        return card ? card.outerHTML : '';
      }).filter(Boolean);
      if (!parts.length) { popInner.innerHTML = '<div class="ee-shop-card__loading">Vorschau nicht verfügbar.</div>'; return; }
      popInner.innerHTML = '<div class="ee-shop-multi">' + parts.join('') + '</div>';
      positionPop(target);
      track('open', { ee_type: 'multi', ee_count: items.length, ee_source: source });
    });
  }

  /* ---------------- In den Warenkorb (Popup) ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.ee-shop-atc');
    if (!btn) return;
    e.preventDefault();
    var vid = btn.getAttribute('data-vid');
    if (!vid) return;
    btn.disabled = true; var old = btn.textContent; btn.textContent = 'Wird hinzugefügt …';
    fetch(CART_ADD, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, body: j }; }); }).then(function (res) {
      if (!res.ok) {
        var body = res.body || {};
        track('add_to_cart_error', { ee_handle: btn.getAttribute('data-handle'), ee_variant: vid, ee_status: res.status, ee_msg: String(body.description || body.message || body.error || '') });
        btn.textContent = 'Fehler — erneut'; btn.disabled = false;
        setTimeout(function () { btn.textContent = old; }, 1800);
        return;
      }
      var data = res.body;
      var added = (data && data.items && data.items[0]) || data || {}; // /cart/add.js mit items[] liefert {items:[...]}
      btn.textContent = '✓ Hinzugefügt';
      track('add_to_cart', { ee_handle: btn.getAttribute('data-handle'), ee_variant: vid });
      // Shopify-Cart-Response inkonsistent: price/final_line_price mal Number (cents), mal String "85.90" (EUR), mal fehlend.
      // toEUR normalisiert beide Formen; Fallback auf p.price aus /products/{handle}.js (immer Number cents).
      function toEUR(v) {
        if (v == null) return undefined;
        if (typeof v === 'string') { var n = parseFloat(v.replace(',', '.')); return isNaN(n) ? undefined : n; }
        return v / 100;
      }
      var atcVal = toEUR(added.final_line_price);
      if (atcVal == null) atcVal = toEUR(added.price);
      if (atcVal == null) {
        var pp = cache['product:' + btn.getAttribute('data-handle')];
        if (pp && typeof pp.then === 'function') {
          pp.then(function (p) { track('ecom_add_to_cart', { currency: 'EUR', value: p && p.price != null ? p.price / 100 : undefined }); });
        } else {
          track('ecom_add_to_cart', { currency: 'EUR', value: undefined });
        }
      } else {
        track('ecom_add_to_cart', { currency: 'EUR', value: atcVal });
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { openMiniCart: true } }));
      // Maestrooo-Warehouse hört NICHT auf 'cart:open' und honoriert detail.openMiniCart nicht.
      // Korrekt: theme-eigenes Toggle-Element (data-action="toggle-mini-cart") klicken — nur wenn
      // Drawer zu ist (sonst würde der Toggle einen offenen Drawer schließen). Kurzer Delay,
      // damit cart:refresh den Drawer-Inhalt erst neu rendert. Toggle macht preventDefault (keine Navigation).
      setTimeout(function () {
        var mc = document.querySelector('#mini-cart');
        var tgl = document.querySelector('[data-action="toggle-mini-cart"]');
        if (tgl && mc && mc.getAttribute('aria-hidden') === 'true') tgl.click();
      }, 150);
      setTimeout(function () { btn.disabled = false; btn.textContent = old; }, 1800);
    }).catch(function (e) {
      track('add_to_cart_error', { ee_handle: btn.getAttribute('data-handle'), ee_variant: vid, ee_status: 0, ee_msg: String((e && e.message) || e) });
      btn.textContent = 'Fehler — erneut'; btn.disabled = false;
      setTimeout(function () { btn.textContent = old; }, 1800);
    });
  });

  // CTA-Klick tracken (Durchklick zum Produkt)
  document.addEventListener('click', function (e) {
    var cta = e.target.closest && e.target.closest('.ee-shop-pop [data-ee-cta], .ee-shop-fig__badge');
    if (cta) track('cta_click', { ee_href: cta.getAttribute('href') || '' });
  });

  // Desktop-Hover-Modus = echtes Hover-Geraet UND breiter Viewport. Sonst (Handy/Tablet/
  // schmaler Emulator) = Tap-Modus. Bewusst breiten-basiert, damit auch maus-basierte
  // Mobil-Emulatoren das Handy-Verhalten zeigen.
  function hoverMode() { return window.matchMedia('(hover: hover)').matches && window.innerWidth >= 768; }

  /* ---------------- Trigger ----------------
     hoverMode(): Hover-Vorschau auf Bildern UND Textlinks (Buttons ausgenommen).
     sonst: KEIN Hover. Bilder oeffnen per Tap/Klick (isImage); Textlinks & Buttons navigieren nativ. */
  function bindTriggersFn(target, doShow, isImage) {
    target.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'touch' || !hoverMode()) return; // nur Desktop-Hover
      clearTimeout(hideTimer);
      showTimer = setTimeout(doShow, HOVER_DELAY);
    });
    target.addEventListener('pointerleave', function () {
      if (!hoverMode()) return;
      clearTimeout(showTimer); scheduleHide();
    });
    target.addEventListener('focus', function () { if (!hoverMode()) return; clearTimeout(hideTimer); doShow(); });
    target.addEventListener('blur', scheduleHide);
    if (isImage) {
      // Tap-Modus (Handy/Emulator): erster Tap aufs Bild -> Popup; offen -> naechster Tap navigiert
      target.addEventListener('click', function (e) {
        if (hoverMode()) return;                              // Desktop: normaler Durchklick
        var openForThis = pop && pop.classList.contains('is-open') && anchorEl === target;
        if (!openForThis) { e.preventDefault(); doShow(); }
      });
    }
  }
  function bindTriggers(target, type, handle, label, source, isImage) {
    bindTriggersFn(target, function () { show(target, type, handle, label, source); }, isImage);
  }

  function handleFromHref(href) {
    if (!href) return null;
    var m = href.split('?')[0].split('#')[0].replace(/\/$/, '');
    var parts = m.split('/');
    return parts[parts.length - 1] || null;
  }
  // Same-origin + Pfad-Prefix; ignoriert externe Domains (z.B. amazon.de/products/...) und
  // mehrsprachige Sub-Pfade (z.B. /de/products/...). /collections/x/products/y -> Produkt y.
  function linkTypeHandle(a) {
    if (a.host && a.host !== location.host) return null;
    var path = a.pathname || '';
    var prodIdx = path.indexOf('/products/');
    if (prodIdx === 0 || (prodIdx > 0 && path.indexOf('/collections/') === 0)) {
      return { type: 'product', handle: handleFromHref(path.substring(prodIdx + 10)) };
    }
    if (path.indexOf('/collections/') === 0) {
      return { type: 'collection', handle: handleFromHref(path.substring(13)) };
    }
    return null;
  }

  /* ---------------- Badges ---------------- */
  function bagIcon() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 7V6a5 5 0 0110 0v1h3v13a2 2 0 01-2 2H6a2 2 0 01-2-2V7h3zm2 0h6V6a3 3 0 00-6 0v1z"/></svg>';
  }
  function defaultLabel(type, label) { return label || (type === 'collection' ? 'Kollektion ansehen' : 'Produkt ansehen'); }
  function buildBadge(type, handle, label, asLink) {
    var el = document.createElement(asLink ? 'a' : 'span');
    el.className = 'ee-shop-fig__badge';
    if (asLink) {
      el.href = (type === 'product' ? '/products/' : '/collections/') + handle; // ohne JS navigierbar
      el.setAttribute('aria-label', defaultLabel(type, label) + ' (Vorschau)');
    } else {
      el.setAttribute('aria-hidden', 'true'); // dekorativ; umschliessender <a> navigiert
    }
    el.innerHTML = bagIcon() + '<span>' + esc(defaultLabel(type, label)) + '</span>';
    return el;
  }
  function isShoppable(img) { return !!(img.__eeBound || img.closest('.ee-shop-fig')); }
  // Opt-in: nur zünden wenn Alt KLAR ein Pflanzkübel-Bild beschreibt (Produkt-Wort) UND
  // genau EIN Material erwähnt. Vermeidet Fehlauslöser auf Vergleichs-Inhalten.
  function materialCollectionFromAlt(alt) {
    var a = (alt || '').toLowerCase();
    if (!/pflanzk(ü|u)bel|(ü|u)bertopf|pflanztrog|pflanzgef(ä|a)(ß|ss)/.test(a)) return null;
    var hasFib = a.indexOf('fiberglas') > -1;
    var hasPoly = a.indexOf('polyrattan') > -1;
    if (hasFib && !hasPoly) return { handle: 'fiberglas', label: 'Fiberglas-Kübel ansehen' };
    if (hasPoly && !hasFib) return { handle: 'polyrattan', label: 'Polyrattan-Kübel ansehen' };
    return null;
  }

  /* ---------------- Bilder shoppbar machen ---------------- */
  // Standalone-Bild (data-Attribut / Theme-Map / Halbautomatik): in <span> wrappen + Badge-<a>
  function makeImageShoppable(img, type, handle, label) {
    if (!img || img.__eeBound || !handle) return; img.__eeBound = true;
    var fig = document.createElement('span');
    fig.className = 'ee-shop-fig';
    var cs = window.getComputedStyle(img);
    if (cs.display === 'block') { fig.style.display = 'block'; fig.style.margin = cs.margin; img.style.margin = '0'; }
    img.parentNode.insertBefore(fig, img);
    fig.appendChild(img);
    var badge = buildBadge(type, handle, label, true);
    fig.appendChild(badge);
    bindTriggers(fig, type, handle, label, 'image', true);
    badge.addEventListener('focus', function () { clearTimeout(hideTimer); show(fig, type, handle, label, 'image'); });
    badge.addEventListener('blur', scheduleHide);
  }
  // Bild, das der Autor im Editor verlinkt hat: <a href="/products|collections/..."><img></a>
  function makeLinkedImageShoppable(a, img, type, handle, label) {
    if (a.__eeBound) return; a.__eeBound = true; img.__eeBound = true;
    a.classList.add('ee-shop-fig');
    var cs = window.getComputedStyle(a);
    if (cs.display === 'inline') a.style.display = 'inline-block';
    a.appendChild(buildBadge(type, handle, label, false)); // Badge dekorativ; der <a> navigiert selbst
    bindTriggers(a, type, handle, label, 'image', true);
  }

  // Standalone-Bild mit MEHREREN Zielen -> Multi-Popup (gestapelt)
  function makeImageShoppableMulti(img, items, label) {
    if (!img || img.__eeBound || !items || !items.length) return; img.__eeBound = true;
    var fig = document.createElement('span');
    fig.className = 'ee-shop-fig';
    var cs = window.getComputedStyle(img);
    if (cs.display === 'block') { fig.style.display = 'block'; fig.style.margin = cs.margin; img.style.margin = '0'; }
    img.parentNode.insertBefore(fig, img);
    fig.appendChild(img);
    var first = items[0];
    var badge = buildBadge(first.type, first.handle, label || (items.length + ' Artikel ansehen'), true);
    fig.appendChild(badge);
    bindTriggersFn(fig, function () { showMulti(fig, items, 'image'); }, true);
    badge.addEventListener('focus', function () { clearTimeout(hideTimer); showMulti(fig, items, 'image'); });
    badge.addEventListener('blur', scheduleHide);
  }

  // Titelbild/Hero (.article__image-wrapper, AUSSERHALB .article__content). Bindet an den WRAPPER,
  // damit das Hero-<img> nicht umgebaut wird (Theme-Layout bleibt intakt). items = ein/mehrere Ziele.
  function makeFeaturedShoppable(wrapper, img, items, label) {
    if (!wrapper || !img || img.__eeBound || !items || !items.length) return; img.__eeBound = true;
    if (window.getComputedStyle(wrapper).position === 'static') wrapper.style.position = 'relative';
    wrapper.classList.add('ee-shop-fig');
    var first = items[0];
    var lbl = label || (items.length > 1 ? (items.length + ' Artikel ansehen') : null);
    var badgeEl = buildBadge(first.type, first.handle, lbl, true);
    wrapper.appendChild(badgeEl);
    var doShow = items.length === 1
      ? function () { show(wrapper, first.type, first.handle, lbl, 'featured'); }
      : function () { showMulti(wrapper, items, 'featured'); };
    bindTriggersFn(wrapper, doShow, true);
    // Tab-Fokus auf den Badge muss dieselbe Vorschau zeigen wie der Wrapper-Hover (sonst
    // bleibt Tab-Nav stumm — Badge hat eigenen Pfad ausserhalb des Wrapper-pointerenter).
    badgeEl.addEventListener('focus', function () { clearTimeout(hideTimer); doShow(); });
    badgeEl.addEventListener('blur', scheduleHide);
  }

  function findImage(scope, match) {
    var imgs = scope.querySelectorAll('img');
    if (typeof match === 'number') return imgs[match] || null;
    var needle = String(match).toLowerCase();
    for (var i = 0; i < imgs.length; i++) {
      var alt = (imgs[i].getAttribute('alt') || '').toLowerCase();
      if (alt.indexOf(needle) > -1) return imgs[i];
    }
    return null;
  }

  function wireImages(scope) {
    // (1) Bild im Produkt-/Collection-Link (Standard: Autor verlinkt das Bild im Editor)
    Array.prototype.forEach.call(scope.querySelectorAll('a[href*="/products/"] img, a[href*="/collections/"] img'), function (img) {
      var a = img.closest('a'); if (!a || a.__eeBound) return;
      var th = linkTypeHandle(a);
      if (th && th.handle) makeLinkedImageShoppable(a, img, th.type, th.handle, a.getAttribute('data-ee-label'));
    });
    // (2) inline data-Attribute
    Array.prototype.forEach.call(scope.querySelectorAll('img[data-ee-product]'), function (img) {
      makeImageShoppable(img, 'product', img.getAttribute('data-ee-product'), img.getAttribute('data-ee-label'));
    });
    Array.prototype.forEach.call(scope.querySelectorAll('img[data-ee-collection]'), function (img) {
      makeImageShoppable(img, 'collection', img.getAttribute('data-ee-collection'), img.getAttribute('data-ee-label'));
    });
    // (3) Theme-Map (m.items = mehrere Ziele -> Multi-Popup; sonst Einzel)
    if (amap && amap.images) {
      amap.images.forEach(function (m) {
        var img = findImage(scope, m.match);
        if (img && !isShoppable(img)) {
          if (m.items && m.items.length) makeImageShoppableMulti(img, m.items, m.label);
          else makeImageShoppable(img, m.type || 'product', m.handle, m.label);
        }
      });
    }
    // (4) Halbautomatik: Material-Stichwort im Alt-Text -> Collection (Fallback)
    Array.prototype.forEach.call(scope.querySelectorAll('img'), function (img) {
      if (isShoppable(img)) return;
      var c = materialCollectionFromAlt(img.getAttribute('alt'));
      if (c) makeImageShoppable(img, 'collection', c.handle, c.label);
    });
  }

  /* Saeule A — Produkt-/Collection-TEXT-Links (Bild-im-Link macht wireImages) */
  function wireLinks(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('a[href*="/products/"], a[href*="/collections/"]'), function (a) {
      if (a.__eeBound) return;            // schon als Bild-im-Link gebunden
      if (a.querySelector('img')) return; // Bild-Links uebernimmt wireImages
      if (a.classList.contains('ee-shop-fig__badge')) return; // Badge gehoert zu wireImages (Multi/Featured/Single-Image)
      var th = linkTypeHandle(a);
      if (!th || !th.handle) return;
      a.__eeBound = true;
      a.classList.add('ee-shop-link');
      // Alle Produkt-/Collection-Links im Artikel (inkl. button-gestylte Chips wie ee-btn):
      // Desktop -> Hover-Vorschau; Mobil/Emulator (hoverMode=false) -> kein Popup, navigiert nativ.
      bindTriggers(a, th.type, th.handle, null, 'link', false);
    });
  }

  /* ---------------- Global ---------------- */
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hidePop(); });
  // Pointer-Typ pro Interaktion merken + Touch-Tap ausserhalb schliesst das Popup
  document.addEventListener('pointerdown', function (e) {
    lastPointerType = e.pointerType || 'mouse';
    if (!hoverMode() && pop && pop.classList.contains('is-open')) {  // Tap-Modus: Tap/Klick ausserhalb schliesst
      if (!pop.contains(e.target) && (!anchorEl || !anchorEl.contains(e.target))) hidePop();
    }
  }, true);
  window.addEventListener('scroll', function () { if (pop && pop.classList.contains('is-open') && anchorEl && hoverMode()) positionPop(anchorEl); }, { passive: true });

  function init() {
    var scope = document.querySelector('.article__content.rte') || document.querySelector('.article__content');
    if (scope) {
      wireImages(scope);  // zuerst Bilder (auch Bild-im-Link) -> markiert behandelte <a>
      wireLinks(scope);   // dann uebrige Text-Links
    }
    // Titelbild/Hero: Asset laedt nur auf Artikelseiten (theme.liquid: page_type=='article'),
    // daher erscheint dieses Popup NUR auf der geoeffneten Artikelseite, NICHT auf Blog-Listen/Tags.
    if (amap && amap.featured && amap.featured.length) {
      var hw = document.querySelector('.article__image-wrapper');
      var himg = hw && hw.querySelector('img');
      if (hw && himg) makeFeaturedShoppable(hw, himg, amap.featured, 'Passende Kübel ansehen');
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
